$(function () {
    setTimeout(function () {
        $('.superform select').change(function () {
            modifyCustomSizingPrice();
        });
        $('.superform input#width').change(function () {
            modifyCustomSizingPrice();
        });
        $('.superform input#height').change(function () {
            modifyCustomSizingPrice();
        });

        modifyCustomSizingPrice();
      console.log("AM I RUNNIONG")
    }, 3000);
});

function modifyCustomSizingPrice() {
    var html = $('#product-tags').html();
    var customer = $('#customer-role').html();
    var price = $('.current-price');
            if ($('select[name=currencies] >> option:selected').first().val() == 'USD') {
                $('.tier5').html('$' + (parseInt(price.html().replace(",", "")) * .9).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                $('.tier10').html('$' + (parseInt(price.html().replace(",", "")) * .85).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                $('.tier25').html('$' + (parseInt(price.html().replace(",", "")) * .8).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                $('.tier50').html('$' + (parseInt(price.html().replace(",", "")) * .75).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))
            }
}